import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
export const DEFAULT_PURCHASE_CYCLE = {
  cycleType: CreativeOffer.CycleType.RECURRING,
  cycleDuration: {
    unit: CreativeOffer.DurationUnit.YEAR,
    count: 1
  }
};
export const DEFAULT_SALE_PURCHASE_CYCLE = {
  cycleType: CreativeOffer.CycleType.RECURRING,
  cycleDuration: {
    unit: CreativeOffer.DurationUnit.YEAR,
    count: 2
  }
};

// Studio color palette — references CSS custom properties defined in
// styles/colors.scss (single source of truth across TS and SCSS).
export const STUDIO_SALE_BG_COLOR = 'var(--studio-sale-bg-color)';
export const STUDIO_SALE_TEXT_COLOR = 'var(--studio-sale-text-color)';
export const STUDIO_CURRENT_PLAN_BG_COLOR = 'var(--studio-current-plan-bg-color)';
export const STUDIO_CURRENT_PLAN_HAT_BG_COLOR = 'var(--studio-current-plan-hat-bg-color)';
export const STUDIO_RECOMMENDED_BG_COLOR = 'var(--studio-recommended-bg-color)';
export const STUDIO_HIGHLIGHT_BG_COLOR = 'var(--studio-highlight-bg-color)';
export const STUDIO_STRIP_BG_COLOR = 'var(--studio-strip-bg-color)';
export const STUDIO_HIGHLIGHT_TEXT_COLOR = 'var(--studio-highlight-text-color)';
export const STUDIO_DARK_COLOR = 'var(--studio-dark-color)';
export const STUDIO_WHITE_COLOR = 'var(--harmony-white)';
export const STUDIO_RECOMMENDED_GRADIENT = 'var(--studio-recommended-gradient)';
export const STUDIO_SELECTED_GRADIENT = 'var(--studio-selected-gradient)';
export const STUDIO_RECOMMENDED_COLUMN_COLOR = 'var(--studio-recommended-column-color)';
export const STUDIO_RECOMMENDED_BADGE_COLOR = 'var(--studio-recommended-badge-color)';
export const STUDIO_CARD_BORDER_COLOR = 'var(--studio-card-border-color)';
export const STUDIO_UNSELECTED_BORDER_COLOR = 'var(--studio-unselected-border-color)';
export const STUDIO_LINK_COLOR = 'var(--studio-link-color)';
export const STUDIO_SECTION_DIVIDER_COLOR = 'var(--studio-section-divider-color)';
export const STUDIO_NEW_BADGE_BG_COLOR = 'var(--studio-new-badge-bg-color)';
//# sourceMappingURL=consts.js.map